import * as common from '@api/common';

const API = {
  common,
};

export default API;
